import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

import { ReportTemplate } from '@/components/views/Report/ReportTemplate';
import { Conclusion } from './Conclusion';
import { ReferenceWeight } from './ReferenceWeight';
import { Diagnostics } from './Diagnostics';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useSandboxExistsReport } from '@/hooks/useSandbox/useSandboxExistsReport';
import { useSandboxSendReport } from '@/hooks/useSandbox/useSandboxSendReport';


export function Result({
	file,
	report,
	sectors,
	formatReport,
	onDownloadPDF,
	isLoadingPDF,
	onChangeComment
}) {
	const history = useHistory();
	const formattedReport = formatReport(report?.data);
	const isLoading = report?.isLoading || sectors?.isLoading || !formattedReport;
	const { company, organization, sendReport, existsReport } = useApplicationContext();

	function handleSendReport() {
		const request = {
			report_type: 'NIOSH',
			id: report.data.id || '',
			company_id: company?.id,
			organization_id: organization?.id
		};
		sendReport(request, '/reporting');

		const currentPath = history.location.pathname;
		const cleanPath = currentPath.match(/(\/reporting\/niosh)/)?.[1];

		if (cleanPath && currentPath !== cleanPath) {
			history.replace(cleanPath);
		}
	}

	const exists = existsReport({
		report_type: 'NIOSH',
		file_id: file?.data.id || '',
		company_id: company?.id,
		organization_id: organization?.id
	});

	const selectedSector = sectors?.data.find((sector) => sector.id === file?.data.sector_id);

	const sections = [
		{
			title: I18n.get('Conclusion'),
			component: <Conclusion formattedReport={formattedReport} />
		},
		{
			title: I18n.get('Reference weight'),
			component: <ReferenceWeight formattedReport={formattedReport} />
		},
		{
			title: I18n.get('Results'),
			component: <Diagnostics formattedReport={formattedReport} />
		}
	];

	if (isLoading) {
		return (
			<Col span={24}>
				<LoadingOutlined />
			</Col>
		);
	}

	return (
		<ReportTemplate
			title={I18n.get('Manual Lifting Report')}
			sections={sections}
			sector={selectedSector}
			fileData={file?.data}
			reportData={report?.data}
			isLoading={isLoading}
			onDownloadPDF={onDownloadPDF}
			isLoadingPDF={isLoadingPDF}
			onChangeComment={onChangeComment}
			handleSendReport={handleSendReport}
			exists={exists}
		/>
	);
}
